import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Modal } from "@lib/modal";
import ModalFooter from "./components/ModalFooter";
import ModalBody from "./components/ModalBody";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { useFixBody } from "@state/hooks/shared";

export default observer(function MyBetsAutosellConfirmation(props: {
	store: CashoutStore;
}) {
	const { t } = useTranslation("mybets");

	useFixBody(true, props.store.isAutosellModalOpen);

	if (!WEBPACK_IS_AUTOCASHOUT_ENABLED || !props.store.isAutosellModalOpen) {
		return null;
	}

	return (
		<ErrorBoundaryWithPropagation
			componentName={
				"Desktop/autosell-confirmation/MyBetsAutosellConfirmation.tsx"
			}
		>
			<Modal>
				<div id="myBetsAutosellConfirmation" className="popup">
					<div className="popup__card popup__card--med">
						<div className="popup__header">
							{t("CASHOUT.AUTO_CASHOUT_HEADER_TITLE")}
						</div>
						<div className="popup__body">
							<ModalBody store={props.store} />
						</div>
						<div className="popup__footer">
							<ModalFooter store={props.store} />
						</div>
					</div>
				</div>
			</Modal>
		</ErrorBoundaryWithPropagation>
	);
});
